export default {
  Roles(state) {
    return state.Roles;
  },
  Nations(state) {
    return state.Nations;
  },
  Partners(state) {
    return state.Partners;
  },
  Packages(state) {
    return state.Packages;
  },
  AddOnFeatures(state) {
    return state.AddOnFeatures;
  },
};